import { useIsAuthenticated } from '@heidi/auth/state';
import { useQuery } from '@tanstack/react-query';

import { GET_CANDIDATE_TEAMS } from '../../contracts/keys';
import { getJoinableTeams } from '../api/teams';
import { getWorkspaceDataConfig, isTransportError } from '../config';
import { useQueryUser } from './useQueryUser';

export { GET_CANDIDATE_TEAMS };

export const useQuerySelfOnboardingTeams = () => {
  const { isAuthenticated } = useIsAuthenticated();
  const { data: user } = useQueryUser();
  return useQuery({
    queryKey: [GET_CANDIDATE_TEAMS],
    enabled: isAuthenticated && !!user && user.can_self_onboard_team,
    queryFn: async () => {
      try {
        const data = await getJoinableTeams();
        return data;
      } catch (error) {
        if (isTransportError(error)) {
          getWorkspaceDataConfig().onSelfOnboardingTeamsFetchError?.(error);
        }
        throw error;
      }
    },
  });
};
